import { ApiError } from "@kundeninfo/api-client";

/**
 * FELDBEFUNDE an ME-Feldern — die eine Stelle für alle Masken (Final-Fixrunde Lieferanten, A-K3; vorher je eine Fassung
 * in Angebot/Auftrag/Rechnung, Belegparteien und den Lieferantenansichten).
 */

/** `fehler` an ein Feld nur, wenn es einen Befund gibt — ausgeschrieben, weil `exactOptionalPropertyTypes` ein
 *  `fehler: undefined` nicht zulässt. */
export const errorProp = (text: string | undefined): { fehler?: string } => (text === undefined ? {} : { fehler: text });

/**
 * Eine 409 mit Feldbezug, die KEIN fremder Stand ist (`ROLLE_HAT_VORGAENGE`, `KREDITOR_VERGEBEN`,
 * `EINGANGSRECHNUNG_DOPPELT`): als Befund am Feld statt als „zwischenzeitlich geändert“ — `useFormularZustand` liest jede
 * 409 als Versionskonflikt.
 */
export async function fieldErrorInsteadOf409<T>(run: () => Promise<T>, codes: readonly string[]): Promise<T> {
  try {
    return await run();
  } catch (e) {
    if (e instanceof ApiError && e.status === 409 && codes.includes(e.code)) {
      throw new ApiError(422, e.code, e.message, e.fields);
    }
    throw e;
  }
}
